// extracted by mini-css-extract-plugin
module.exports = {"auth-button":"ButtonWrapper--auth-button--1a6V0","authButton":"ButtonWrapper--auth-button--1a6V0"};